__turbopack_context__.v({
  "backButton": "EntitySettingsContent-module__aCNM4W__backButton",
  "container": "EntitySettingsContent-module__aCNM4W__container",
  "profileAvatar": "EntitySettingsContent-module__aCNM4W__profileAvatar",
  "verifyVoteGroup": "EntitySettingsContent-module__aCNM4W__verifyVoteGroup",
});
